import { render } from "./TooltipButton.vue?vue&type=template&id=53ea747a"
import script from "./TooltipButton.vue?vue&type=script&lang=js"
export * from "./TooltipButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__